var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup44566(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2224_5588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.63672,
    y: 1.63574,
    width: 14.7273,
    height: 14.7273,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2224_5588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56222 13.295L4.70312 12.4359L8.13949 8.99956L4.70312 5.56319L5.56222 4.7041L8.99858 8.14047L12.4349 4.7041L13.294 5.56319L9.85767 8.99956L13.294 12.4359L12.4349 13.295L8.99858 9.85865L5.56222 13.295Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup44566);
export default __webpack_public_path__ + "static/media/Group 44566.557f1bef6964a4f607451c31ee2d4fdd.svg";
export { ForwardRef as ReactComponent };